import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import RedesignModal from '../../../../shared/components/RedesignModal';
import { useResumeTestModalStyles } from './ResumeTestModal.styles';

export type ResumeTestModalProps = {
  open: boolean;
  testTitle?: string;
  questionNumber?: number;
  totalQuestions?: number;
  onClose: () => void;
  onResume: () => void;
  onRestart: () => void;
};

const ResumeTestModal = ({
  open,
  testTitle = 'Test',
  questionNumber = 1,
  totalQuestions,
  onClose,
  onResume,
  onRestart,
}: ResumeTestModalProps) => {
  const classes = useResumeTestModalStyles();

  const progress = totalQuestions ? Math.min((questionNumber / totalQuestions) * 100, 100) : 0;

  return (
    <RedesignModal
      open={open}
      onClose={onClose}
      labelledBy="resume-test-modal-title"
      paperClassName={classes.modal}>
      <div className={classes.headerBlock}>
        <div className={classes.headerTop}>
          <Typography id="resume-test-modal-title" component="h2" className={classes.title}>
            Reprendre votre test
          </Typography>
          <IconButton className={classes.close} onClick={onClose} aria-label="Fermer">
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        <Typography className={classes.description}>
          Il semblerait que vous ayez un test en cours. Souhaitez-vous reprendre là où vous vous
          étiez arrêté ?
        </Typography>
      </div>

      <div className={classes.card}>
        <Typography className={classes.cardLabel}>Test en cours</Typography>
        <Typography className={classes.cardTitle}>{testTitle}</Typography>
        <div className={classes.progressRow}>
          <div className={classes.progressTrack} aria-hidden="true">
            <div className={classes.progressFill} style={{ width: `${progress}%` }} />
          </div>
          <Typography className={classes.progressText}>
            Question {questionNumber}/{totalQuestions || '?'}
          </Typography>
        </div>
      </div>

      <div className={classes.actions}>
        <Button
          className={classes.resumeButton}
          startIcon={<PlayArrowIcon />}
          onClick={onResume}
          fullWidth={true}>
          Reprendre le test
        </Button>
        <Button
          variant="outlined"
          className={classes.restartButton}
          onClick={onRestart}
          fullWidth={true}>
          Recommencer depuis le début
        </Button>
      </div>
    </RedesignModal>
  );
};

export default ResumeTestModal;
